"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorage = void 0;
var lokijs_1 = __importDefault(require("lokijs"));
var mobx_1 = require("mobx");
var date_fns_1 = require("date-fns");
//@ts-ignore
var loki_indexed_adapter_1 = __importDefault(require("lokijs/src/loki-indexed-adapter"));
var LocalStorage = /** @class */ (function () {
    function LocalStorage(appName, collName, indices, fetchFn) {
        this.collName = collName;
        this.indices = indices;
        this.fetchFn = fetchFn;
        this.searchCollLoaded = false;
        var idb = new loki_indexed_adapter_1.default();
        this.db = new lokijs_1.default(appName, {
            env: 'BROWSER',
            adapter: idb,
            autoload: true,
            autoloadCallback: this.initializeDB.bind(this),
            autosave: true,
            autosaveInterval: 4000
        });
    }
    LocalStorage.prototype.getCollsOrInitializeIfNotExists = function () {
        var coll = this.db.getCollection(this.collName);
        var lucoll = this.db.getCollection(this.collName + "_lastUpdate");
        if (!coll) {
            coll = this.db.addCollection(this.collName, { indices: this.indices });
        }
        if (!lucoll) {
            lucoll = this.db.addCollection(this.collName + "_lastUpdate", { indices: 'lastUpdate' });
        }
        return [coll, lucoll];
    };
    LocalStorage.prototype.initializeDB = function () {
        var _this = this;
        var _a = __read(this.getCollsOrInitializeIfNotExists(), 2), coll = _a[0], lucoll = _a[1];
        this.fetchFn
            .then(function (items) {
            coll.clear();
            items[1].forEach(function (i) {
                coll.insert(i);
            });
            _this.coll = coll;
            lucoll.clear();
            lucoll.insert({ lastUpdate: items[0][0].last_update });
            _this.lastUpdate = date_fns_1.parseISO(items[0][0].last_update);
            mobx_1.runInAction(function () {
                _this.searchCollLoaded = true;
            });
        }).catch(function (_) {
            var _a;
            _this.coll = coll;
            var lu = date_fns_1.parseISO((_a = lucoll === null || lucoll === void 0 ? void 0 : lucoll.data[0]) === null || _a === void 0 ? void 0 : _a.lastUpdate);
            _this.lastUpdate = date_fns_1.isValid(lu) ? lu : date_fns_1.parseISO('2020-04-30');
            mobx_1.runInAction(function () {
                _this.searchCollLoaded = true;
            });
        });
    };
    LocalStorage.prototype.query = function (q) {
        if (!this.coll) {
            return [];
        }
        return this.coll.find(q);
    };
    __decorate([
        mobx_1.observable
    ], LocalStorage.prototype, "searchCollLoaded", void 0);
    return LocalStorage;
}());
exports.LocalStorage = LocalStorage;
